'use client';

import { ISalePageDetailResponseGachaReward } from '@/api/types';
import { useFoldDescription } from '@/app/sales/components/description/useFoldDescription';
import { Button } from '@/components';
import { Column, Element } from '@vuddy/components';
import { useState } from 'react';
import * as styles from './gachaProbability.css';
import { GachaContentProbabilityTable } from './GachaProbabilityTable';

interface IGachaContentProbabilityProps {
  isProxyCompleteAllowed: boolean;
  rewards: ISalePageDetailResponseGachaReward[];
}

export const GachaContentProbability = ({
  isProxyCompleteAllowed,
  rewards,
}: IGachaContentProbabilityProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { isCalculating, isOverflown, htmlRefCallback } = useFoldDescription({
    description: '',
  });

  return (
    <>
      <Column
        padding="padding_base"
        gap="gap_3xl"
        borderRadius="radius_large"
        backgroundColor="whiteQuaternary"
        id="probability">
        <Element typography="titleSmall" color="whitePrimary">
          확률 정보
        </Element>

        <Element
          className={styles.htmlWrapper({
            isExpanded,
            isOverflown,
            isCalculating,
          })}>
          <Column gap="gap_xl" ref={htmlRefCallback}>
            <Column gap="gap_base">
              <Element typography="bodyXsAccent" color="whitePrimary">
                확률 안내
              </Element>
              <ul className={styles.ul}>
                <li className={styles.li}>
                  아래 확률은 구성 아이템의 개별 획득 확률을 나타내며, 실제
                  지급된 아이템의 확률은 아래 표와 일치합니다.
                </li>
              </ul>
            </Column>
            <GachaContentProbabilityTable isProxy={false} rewards={rewards} />
            {isProxyCompleteAllowed ? (
              <>
                <Column gap="gap_base">
                  <Element typography="bodyXsAccent" color="whitePrimary">
                    대리 가챠 확률 안내
                  </Element>
                  <ul className={styles.ul}>
                    <li className={styles.li}>
                      아래 확률은 대리 가챠로 진행될 경우, 각 구성 아이템의 개별
                      획득 확률을 나타내며, 실제 지급된 아이템의 확률은 아래
                      표와 일치합니다.
                    </li>
                  </ul>
                </Column>
                <GachaContentProbabilityTable isProxy rewards={rewards} />
              </>
            ) : null}
          </Column>
        </Element>

        {(isOverflown || isExpanded) && (
          <>
            <Element
              paddingX="padding_large"
              paddingTop={isExpanded ? undefined : 'padding_base'}
              paddingBottom="padding_base"
              position="relative">
              {!isExpanded ? (
                <Column width="100%" height={40} className={styles.dimmed} />
              ) : null}
              <Button
                variant="outlineWhite"
                size="medium"
                onClick={() => setIsExpanded(isExpanded => !isExpanded)}
                fullWidth>
                {isExpanded ? '접기' : '더보기'}
              </Button>
            </Element>
          </>
        )}
      </Column>
    </>
  );
};
